import { IAction } from '@Root/types'

export const WorkspaceActionTypes = {
  RESET_WORKSPACES:'@@workspace/RESET_WORKSPACES',
  RESET_CURRENT_WORKSPACE: '@@workspace/RESET_CURRENT_WORKSPACE',
  SET_CURRENT_WORKSPACE: '@@workspace/SET_CURRENT_WORKSPACE',
  CREATE_WORKSPACE: '@@workspace/CREATE_WORKSPACE',
  CREATE_WORKSPACE_SUCCESS: '@@workspace/CREATE_WORKSPACE_SUCCESS',
  CREATE_WORKSPACE_FAILURE: '@@workspace/CREATE_WORKSPACE_FAILURE',
  RENAME_WORKSPACE: '@@workspace/RENAME_WORKSPACE',
  RENAME_WORKSPACE_SUCCESS: '@@workspace/RENAME_WORKSPACE_SUCCESS',
  RENAME_WORKSPACE_FAILURE: '@@workspace/RENAME_WORKSPACE_FAILURE',
  DELETE_WORKSPACES: '@@workspace/DELETE_WORKSPACES',
  DELETE_WORKSPACES_SUCCESS: '@@workspace/DELETE_WORKSPACES_SUCCESS',
  DELETE_WORKSPACES_FAILURE: '@@workspace/DELETE_WORKSPACES_FAILURE',
  CHANGE_SELECTED_WORKSPACES: '@@workspace/CHANGE_SELECTED_WORKSPACES',
  UNSELECT_WORKSPACES: '@@workspace/UNSELECT_WORKSPACES',
  SELECT_ALL_WORKSPACES: '@@workspace/SELECT_ALL_WORKSPACES',
}

export interface IWorkspaceState {
  readonly workspaces: IWorkspace[]
  readonly currentWorkspaceId: number
  readonly selectedWorkspaceIds: number[]
  readonly saving: boolean
  readonly hasRenamedWorkspaceSuccessfully: boolean
}

export interface IWorkspace {
  readonly id: number
  readonly attributes: IWorkspaceAttributes
}

export interface IWorkspaceData {
  readonly id: string
  readonly type: 'workspace'
  readonly attributes: IWorkspaceAttributes
}

export interface IWorkspaceAttributes {
  readonly name: string
  readonly ignoredDefaultGuidelines: number[]
  readonly hasActiveElements: boolean
  readonly isNew: boolean
  readonly lastUsedTtsProjectVersionLanguage?: string
  readonly createdAt: string
  readonly numberOfProjects: number
}

export interface ISetCurrentWorkspacePayload {
  readonly workspaceId: number
}

export interface ICreateWorkspacePayload {
  readonly accountId: number
  readonly workspaceName: string
}

export interface ICreateWorkspaceSuccessResponseBody {
  readonly data: IWorkspaceData
}

export interface IRenameWorkspacePayload {
  readonly workspaceId: number
  readonly name: string
}

export type IRenameWorkspaceSuccessPayload = IRenameWorkspacePayload

export interface IDeleteWorkspacesPayload {
  readonly workspaceIds: number[]
}

export type IDeleteWorkspacesSuccessPayload = IDeleteWorkspacesPayload

export interface IChangeSelectedWorkspacesPayload {
  readonly workspaceId: number
  readonly selectWorkspace: boolean
}

export type TWorkspaceActionTypes =
  IAction<ISetCurrentWorkspacePayload> |
  IAction<ICreateWorkspaceSuccessResponseBody> |
  IAction<IRenameWorkspaceSuccessPayload> |
  IAction<IDeleteWorkspacesSuccessPayload> |
  IAction<IChangeSelectedWorkspacesPayload>
